import { hasProp } from "~/utils/common"

export type ApiErrorResponse = {
	message: string
	traceId: string
	statusCode: number
	timestamp?: number
	validationCode?: string
	metadata?: Record<string, unknown>
	errorCode?: string
	id?: string
}

export function isApiErrorResponse(v: unknown): v is ApiErrorResponse {
	return (
		hasProp(v, "message") &&
		typeof v.message === "string" &&
		hasProp(v, "traceId") &&
		typeof v.traceId === "string" &&
		hasProp(v, "statusCode") &&
		typeof v.statusCode === "number"
	)
}
